export const tenantFeatureFlagNames = {
    UseInvoices: 'useInvoices',
    UseLotKpis: 'useLotKpis',
    UseAmazonStorageReport: 'useAmazonStorageReport',
    UseStorageReport: 'useStorageReport',
    UseOneOnOne: 'useOneOnOne',
    UseInspections: 'useInspections',
    UseLotAccess: 'useLotAccess',
    UseMobileApp: 'useMobileApp',
    UseUserTasks: 'useUserTasks',
    UseVendorQuoteButton: 'useVendorQuoteButton',
    // SCN-633 -- gates visibility of the Lot Close/Deprecate admin actions. Defaults to
    // OFF for every tenant (TenantFeatureFlag treats anything other than === true as not
    // allowed, including a tenant config response that doesn't have this key at all --
    // true for every tenant until someone explicitly enables it here). Do not enable in
    // production until PR-5 (backend write guard) is live and validated, per
    // 05-web-design.md.
    UseLotLifecycleActions: 'useLotLifecycleActions',
}

export const tenantFeatureFlagLabels = {
    [tenantFeatureFlagNames.UseInvoices]: "Use Invoicing",
    [tenantFeatureFlagNames.UseLotKpis]: "Use Lot KPIs (dashboard)",
    [tenantFeatureFlagNames.UseAmazonStorageReport]: "Use Amazon Storage Report",
    [tenantFeatureFlagNames.UseStorageReport]: "Use Daily Storage Report (Element/HUB)",
    [tenantFeatureFlagNames.UseOneOnOne]: "Use One On One",
    [tenantFeatureFlagNames.UseInspections]: "Use Inspections",
    [tenantFeatureFlagNames.UseUserTasks]: "Use User Tasks",
    [tenantFeatureFlagNames.UseLotAccess]: "Use Lot Access",
    [tenantFeatureFlagNames.UseMobileApp]: "Use Mobile App",
    [tenantFeatureFlagNames.UseVendorQuoteButton]: "Use Vendor Quote Button (email)",
    [tenantFeatureFlagNames.UseLotLifecycleActions]: "Use Lot Close/Deprecate Actions (SCN-633, keep OFF until backend guard is live)",
}

export const tenantDispatchNames = {
    DispatchName: 'dispatchName',
    DispatchEmail: 'dispatchEmail',
    DispatchPhone: 'dispatchPhone',
}

export const tenantDispatchLabels = {
    [tenantDispatchNames.DispatchName]: "Dispatch Name",
    [tenantDispatchNames.DispatchEmail]: "Dispatch Email",
    [tenantDispatchNames.DispatchPhone]: "Dispatch Phone",
}